export default "__VITE_PUBLIC_ASSET__cad3fd77__"